import { useAppStore } from '../store/useAppStore';

// Shared plumbing for mutation feedback: clears stale messages, runs the
// action, shows the success message or surfaces the error. Pass no
// successMessage for silent success (errors are always shown).
export function useMutationFeedback() {
  const clearMessages = useAppStore((state) => state.clearMessages);
  const setStatusMessage = useAppStore((state) => state.setStatusMessage);
  const setErrorMessage = useAppStore((state) => state.setErrorMessage);

  const run = async (action, successMessage) => {
    clearMessages();
    try {
      await action();
      if (successMessage !== undefined) {
        setStatusMessage(successMessage);
      }
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  const fail = (message) => {
    clearMessages();
    setErrorMessage(message);
  };

  return { run, fail };
}
